export default "assets/images/logo-7861d39f.svg";